var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1350,
    height: 15,
    viewBox: "0 0 1350 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5H1349.97V15H5.02081L0 12.5Z",
    fill: "#003E6B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1350,
    height: 12.5,
    fill: "#668BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelf);
export default __webpack_public_path__ + "static/media/shelf.5bd0794947f50c28a62756791b1795cd.svg";
export { ForwardRef as ReactComponent };